<template>
	<button class="share-link-button" type="button" @click="handlerShareButtonOnClick">
		<span class="nav-icon icon-share" aria-hidden="true" v-html="icons.share" />
		<span class="share-link-text">{{ text }}</span>
	</button>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { icons } from '@shared-assets/icons-v2'

export default defineComponent({
	name: 'ShareLink',
	props: {
		// 按鈕文字
		text: {
			type: String,
			required: true,
		},
	},
	emits: ['share'],
	setup(_, { emit }) {
		/**
		 * 點擊分享按鈕的事件
		 * @return {void}
		 */
		const handlerShareButtonOnClick = (): void => emit('share')

		return {
			icons,
			handlerShareButtonOnClick,
		}
	},
})
</script>
<style lang="scss">
// v3 Share 視窗的複製連結按鈕
.share-link-button {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	height: 48px;
	padding: 0 40px;
	// em 的換算基準，icon 跟著字級縮放
	font-size: 20px;
	font-family: inherit;
	background: var(--ui-white);
	border: 0.5px solid rgba(0, 0, 0, 0.3);
	border-radius: 16px;
	color: var(--ui-grey-darkest);
	cursor: pointer;
	transition: background 0.2s ease;

	&:hover {
		background: #f1f1ef;
	}

	.share-link-text {
		// Figma 在文字外層加了 padding-top 做視覺置中
		padding-top: 2px;
		font-size: 20px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		white-space: nowrap;
	}
}
</style>
